<template>
    <Head>
        <title>Wakaf Pahang - Pembayaran wakaf melalui kaunter</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <header class="container-fluid p-2 bg-wakaf-primary">
        <div class="d-flex flex-column align-items-center">
            <h1 class="fs-3 text-white">Pembayaran wakaf melalui kaunter </h1>
        </div>
    </header>
    <form novalidate @submit.prevent="submitForm">
        <div class="container">
            <div class="row mt-3">
                <div class="col-md-3">
                    <p class="fs-4 text-center">Maklumat Pembayar</p>
                    <div class="shadow rounded p-3">
                        <span class="fs-6">Nama: </span>
                        <p class="fs-6 fw-bold">{{ info.nama }}</p>
                        <span class="fs-6">No. Telefon Bimbit: </span>
                        <p class="fs-6 fw-bold">{{(info.telefonbimbit !== "") ? info.telefonbimbit : "Tiada nombor telefon" }}</p>
                        <span class="fs-6">Daerah: </span>
                        <p class="fs-6 fw-bold">{{ info.daerah || "Tiada data" }}</p>
                        <span class="fs-6">No. Kad Pengenalan Diri: </span>
                        <p class="fs-6 fw-bold">{{ info.nokp }}</p>
                        <span class="fs-6">E-mel: </span>
                        <p class="fs-6 fw-bold">{{ info.emel ? info.emel : "Tiada e-mel" }}</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="my-3">
                        <label class="form-label w-100">Cara Pembayaran</label>
                        <template v-for="(bayar) in bayarr">
                            <div class="form-check form-check-inline">
                                <input type="radio" name="caraBayar" :value="bayar.ID" :id="'cara_'+bayar.ID"
                                       @change="updateValues($event)" :class="{ 'is-invalid':counter.catatanBool }"
                                       class="form-check-input" v-model="counter.caraBayar">
                                <label class="form-check-label" :for="'cara_'+bayar.ID">{{ bayar.nama }}</label>
                            </div>
                        </template>
                        <div class="invalid-feedback d-block" v-if="counter.caraBayarBool">{{ counter.caraBayarMsg }}</div>
                    </div>
                    <div class="my-3" v-if="counter.caraBayar !== 1">
                        <label class="form-label" for="noCekRujukan">No Cek/Rujukan</label>
                        <input name="noCekRujukan" type="text" id="noCekRujukan" class="form-control" :class="{ 'is-invalid':counter.noCekRujukanBool }"
                               placeholder="No Cek/Rujukan" v-model="counter.noCekRujukan">
                    </div>
                    <div class="mb-3" v-if="counter.caraBayar !== 1">
                        <label class="form-label" for="bank">Bank</label>
                        <select class="form-select" name="bank" id="bank" v-model="counter.bank" :class="{ 'is-invalid':counter.bankBool }">
                            <option value="" selected disabled>Sila Pilih</option>
                            <option v-for="bank in bankk" :value=" bank.ID ">{{ bank.NamaBank }}</option>
                        </select>
                        <div class="invalid-feedback d-block" v-if="counter.bankBool">{{ counter.bankMsg }}</div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="catatan">Catatan</label>
                        <input type="text" id="catatan" class="form-control" v-model="counter.catatan" autocomplete="nickname" :class="{ 'is-invalid':counter.catatanBool }"
                               placeholder="Catatan">
                        <div class="invalid-feedback d-block" v-if="counter.catatanBool">{{ counter.catatanMsg }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <p class="fs-4 text-center">Maklumat Pegawai</p>
                    <div class="shadow rounded p-3">
                        <span class="fs-6">Nama pegawai :</span>
                        <p class="fs-6 fw-bold">{{ officer.nama }}</p>
                        <span class="fs-6">Kod pegawai :</span>
                        <p class="fs-6 fw-bold">{{ officer.kodpegawai }}</p>
                        <span class="fs-6">Pejabat :</span>
                        <p class="fs-6 fw-bold">{{ office_name }}</p>
                    </div>
                    <div class="mb-2 mt-2">
                        <label for="KataLaluan" class="form-label">Kata laluan pegawai</label>
                        <input v-model="counter.KataLaluan" type="password" id="KataLaluan" class="form-control" :class="{ 'is-invalid':counter.KataLaluanBool }"
                               autocomplete="current-password" placeholder="Kata laluan pegawai" />
                        <div class="invalid-feedback d-block" v-if="counter.KataLaluanBool">{{ counter.KataLaluanMsg }}</div>
                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid">
            <section class="mt-5">
                <wakaf-data ref="wakafDataRef" :wakaf_type='wakaf_type' :wakaf_district='wakaf_district'
                            :wakaf_project='wakaf_project'
                            :nama_pewakaf="info.nama" :w_id="data.wid" :d_id="data.did" @calulate-sum="calculateSum"
                            :userdata='userdata'></wakaf-data>
                <div class="d-flex justify-content-between" style="margin-bottom: 200px">
                    <button v-if="isDisplayGrandSumAndSubmit" class="btn btn-danger px-4" :class="[showCloseBtn ? '' : 'd-none']"
                            @click="cancelFormSubmit"
                            type="button"><font-awesome-icon :icon="faXmark" />&nbsp;&nbsp;Batal
                    </button>
                    <span v-if="isDisplayGrandSumAndSubmit" class="fs-6 fw-bold btn btn-outline-primary">Jumlah keseluruhan : {{sumFormat(sum) }}</span>
                    <button type="button" v-if="isDisplayGrandSumAndSubmit" @click="validateData" class="btn btn-success" style="right: 0" ><font-awesome-icon :icon="faForward" /> Seterusnya</button>
                </div>
            </section>
        </div>
        <Modal ref="modalWakaf">
            <template #Header>
                <div class="d-flex justify-content-between mb-2">
                    <p class="fs-3">Pengesahan maklumat wakaf bagi {{ data.info.nama}}</p>
                    <button type="button" @click="modalWakaf.closeModal()" class="btn"><font-awesome-icon :icon="faXmark" /></button>
                </div>
            </template>
            <template #Body>
                <div class="table-responsive" :class="[custom.popupBody]">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Jenis Wakaf</th>
                            <th scope="col">Keterangan</th>
                            <th scope="col">Unit</th>
                            <th scope="col">Nama</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(transaction, index) in wakafDataRef.wakafData" v-if="wakafDataRef !== null">
                            <td>{{ index + 1 }}</td>
                            <td v-if="transaction.jenisWakaf === 1">Tabung Wakaf Umum</td>
                            <td v-else-if="transaction.jenisWakaf === 2">Wakaf Projek</td>
                            <td v-else-if="transaction.jenisWakaf === 3">Tabung Wakaf Masjid</td>
                            <td v-else-if="transaction.jenisWakaf === 4">Tabung Wakaf Pendidikan</td>
                            <td v-else-if="transaction.jenisWakaf === 5">Wakaf Tunai</td>
                            <td v-if="transaction.jenisWakaf === 1">{{ displayDaerah(transaction.daerahWakaf) + " - Tabung Wakaf Tunai" }}</td>
                            <td v-else-if="transaction.jenisWakaf === 2">{{  displayDaerah(transaction.daerahWakaf) + " - " + displayProject(transaction.projekWakaf) }}</td>
                            <td v-else><span class="fs-6">Tidak berkaitan</span></td>
                            <td>{{ transaction.unit }}</td>
                            <td>{{ ((transaction.jenisPemilik === "Mewakili Orang Meninggal")? "Arwah ":"").concat(transaction.namaPemilik) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template #Footer>
                <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-success"><font-awesome-icon :icon="faPaperPlane" />  Hantar</button>
                </div>
            </template>
        </Modal>
    </form>
    <footerFPX :year="currentYear"></footerFPX>
</template>

<script setup lang="ts">
import {sumFormat} from "@/utils/utils";
import {onMounted, Ref, ref} from "vue";
import axios from "axios";
import { Head } from '@inertiajs/vue3';
import Swal from "sweetalert2";
import {faPlus, faMinus, faPaperPlane, faXmark, faForward} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faPlus, faMinus, faPaperPlane, faXmark, faForward);

import WakafData from "./transactionCounter.vue";
import FooterFPX from "./footerFPX.vue";
import custom from "../../../scss/app.module.scss";
import Modal from "../../components/modal.vue";
import type {FormGeneral} from "../interface/FormGeneral";
const isDisplayGrandSumAndSubmit = ref<boolean>(false);
const data = defineProps<{
    currentYear: number,
    img_wakafpahang: string,
    img_wakafconfrim: string,
    img_favicon: string,
    csrf: string,
    submit_url: string,
    info: {
        nama: string,
        telefonbimbit: string,
        daerah: string,
        nokp: string,
        emel: string
    },
    bankk: [{
        ID:number,
        NamaBank:string
    }],
    bayarr: [{
        ID:number,
        nama:string
    }],
    district: [{
        KodDaerah: number,
        daerah: string,
    }],
    officer: {
        nama: string,
        kodpegawai: string,
        namapejabat: string,
        kodpejabat: string
    },
    wakaf_type: [{
        id:number,
        Nama:string
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project:  [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    kpeg: string,
    kpej: number,
    office_name: string,
    wid?: number,
    did?: number,
    userdata?: [IuserData],
}>();

interface Counter{
    caraBayar: number,
    caraBayarBool: boolean,
    caraBayarMsg: string,
    noCekRujukan: string,
    noCekRujukanBool: boolean,
    noCekRujukanMsg: string,
    bank: string,
    bankBool: boolean,
    bankMsg: string,
    catatan: string,
    catatanBool: boolean,
    catatanMsg: string,
    KataLaluan: string,
    KataLaluanBool: boolean,
    KataLaluanMsg: string,
}

interface IuserData {
    ID: number,
    JenisWakaf: number,
    KodDaerah: number,
    Projek: number,
    Unit: number,
    jumlah: number,
    JenisPemilikan: string,
    NamaPemilik: string,
    Amaun: number,
    NoResitt: number,
    WakafResitID: number
}

const counter = ref<Counter>({
    caraBayar: 1,
    caraBayarBool: false,
    caraBayarMsg: "",
    noCekRujukan: "",
    noCekRujukanBool: false,
    noCekRujukanMsg: "",
    bank: "",
    bankBool: false,
    bankMsg: "",
    catatan: "Bayaran wakaf",
    catatanBool: false,
    catatanMsg: "",
    KataLaluan: "",
    KataLaluanBool: false,
    KataLaluanMsg: "",
});

const showCloseBtn: Ref = ref<boolean>(false);
const sum: Ref = ref<number>();
const wakafDataRef: Ref = ref<InstanceType<typeof WakafData> | null>(null);
const modalWakaf: Ref = ref<InstanceType<typeof Modal> | null>(null);

const updateValues = (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (parseInt(target.value) !== 1) {
        counter.value.noCekRujukan = "";
        counter.value.bank = "";
    }
}

const validateData = (): void =>{
    let formValidation: boolean = true;
    counter.value.caraBayarBool = false;
    counter.value.noCekRujukanBool = false;
    counter.value.noCekRujukanBool = false;
    counter.value.catatanBool = false;
    counter.value.KataLaluanBool = false;

    if(counter.value.caraBayar === 0){
        formValidation = false;
        counter.value.caraBayarBool = true;
        counter.value.caraBayarMsg = "Cara pembayaran tidak dipilih";
    }
    if(counter.value.caraBayar !== 1 && counter.value.noCekRujukan === ""){
        formValidation = false;
        counter.value.noCekRujukanBool = true;
        counter.value.noCekRujukanMsg = "No Cek/Rujukan mesti diisi";
    }
    if(counter.value.caraBayar !== 1 && counter.value.bank === ""){
        formValidation = false;
        counter.value.noCekRujukanBool = true;
        counter.value.noCekRujukanMsg = "Bank tidak dipilih";
    }
    if(counter.value.catatan === ""){
        formValidation = false;
        counter.value.catatanBool = true;
        counter.value.catatanMsg = "Catatan mesti diisi";
    }
    if(counter.value.KataLaluan === ""){
        formValidation = false;
        counter.value.KataLaluanBool = true;
        counter.value.KataLaluanMsg = "Kata laluan kosong";
    }

    wakafDataRef.value?.wakafData.forEach((item: FormGeneral) => {
        if(item.jenisWakaf === 0){
            formValidation = false;
        }
        if(item.daerahWakaf === 0){
            formValidation = false;
        }
        if(item.jenisWakaf === 2 && item.daerahWakaf !== 0 && item.projekWakaf === 0){
            formValidation = false;
        }
        if(item.jenisPemilik === ""){
            formValidation = false;
        }
        if(item.namaPemilik === ""){
            formValidation = false;
        }
    });
    if(formValidation){
        modalWakaf.value.showModal();
    }
}

const formData = () : void => {

}

const submitForm = (): void => {
    let jenisWakaff : number[] = [];
    let daerahWakaff : number[] = [];
    let projekWakaff : number[] = [];
    let unitt : number[] = [];
    let jumlahh : number[] = [];
    let jenisPemilikk : string[] = [];
    let namaPemilikk : string[] = [];
    wakafDataRef.value?.wakafData.forEach((item: FormGeneral) => {
        jenisWakaff.push(item.jenisWakaf);
        daerahWakaff.push(item.daerahWakaf);
        projekWakaff.push(item.projekWakaf);
        unitt.push(item.unit);
        jumlahh.push(item.jumlah);
        jenisPemilikk.push(item.jenisPemilik);
        namaPemilikk.push(item.namaPemilik);
    });
    modalWakaf.value.closeModal();
    const formData: {
        csrf: string,
        caraBayar: number,
        noCekRujukan: string,
        catatan: string,
        kataLaluan: string,
        kpej: number,
        kpeg: string,
        jenisWakaf: number[],
        daerahWakaf: number[],
        projekWakaf: number[],
        unit: number[],
        jumlah: number[],
        jenisPemilik: string[],
        namaPemilik: string[],
        bank?: string,
    }
    = {
        csrf: data.csrf,
        caraBayar: counter.value.caraBayar,
        noCekRujukan: counter.value.noCekRujukan,
        catatan: counter.value.catatan,
        kataLaluan: counter.value.KataLaluan,
        kpej: data.kpej,
        kpeg: data.kpeg,
        jenisWakaf: jenisWakaff,
        daerahWakaf: daerahWakaff,
        projekWakaf: projekWakaff,
        unit: unitt,
        jumlah: jumlahh,
        jenisPemilik: jenisPemilikk,
        namaPemilik: namaPemilikk,
    }
    if(counter.value.caraBayar !== 1){
        formData["bank"] = counter.value.bank;
    }
    Swal.fire({
        title: "Anda pasti untuk hantar?",
        html: `Sila baca lafaz wakaf beserta nilai iaitu <b> ${sumFormat(sum.value)}</b>. Tekan Ya untuk teruskan`,
        imageUrl: data.img_wakafconfrim,
        imageWidth: 128,
        imageHeight: 128,
        showConfirmButton: true,
        confirmButtonColor: "#198754",
        confirmButtonText: "Ya, saya mewakili pewakaf",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd",
        reverseButtons: true,
        allowOutsideClick: () => !Swal.isLoading(),
        showLoaderOnConfirm: true,
        preConfirm: () => {
            // return 0
            return axios({
                method: "post",
                url: data.submit_url,
                data: formData
            }).then(function (response) {
                window.location.href = response.data;
            }).catch(function (error) {
                Swal.fire({
                    icon: "error",
                    title: "Ralat berlaku",
                    text: "Sila cuba semula untuk hantar. " + error.response.data.message,
                    timer: 5000,
                    timerProgressBar: true,
                    confirmButtonColor: "#0d6efd",
                    confirmButtonText: "Ok",
                })
            });
        },
    })
}

const cancelFormSubmit = () => {
    Swal.fire({
        position: "top",
        icon: "question",
        title: "Anda pasti untuk batal?",
        showConfirmButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Ya",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd"
    }).then((result) => {
        if (result.isConfirmed) {
            window.close()
        }
    })
}
const calculateSum = (summ: number) : void =>{
    if(wakafDataRef.value.wakafData.length === 0) {
        isDisplayGrandSumAndSubmit.value = false;
        sum.value = 0;
    } else if (wakafDataRef.value.wakafData.length > 0) {
        isDisplayGrandSumAndSubmit.value = true;
        sum.value = summ;
    }
}

onMounted(() => {
    if (window.opener !== null) {
        showCloseBtn.value = true;
    }
});

const displayDaerah = (daerah: number) : string =>{
    let textDisplay: string = "";
    for(let i: number= 0; i < data.wakaf_district.length; i++){
        if(daerah === data.wakaf_district[i].KodDaerah){
            textDisplay += data.wakaf_district[i].daerah;
        }
    }
    return textDisplay;
}
const displayProject = (projek: number) : string =>{
    let textDisplay: string = "";
    for(let j: number= 0; j < data.wakaf_project.length; j++){
        if(projek === data.wakaf_project[j].kod){
            textDisplay += data.wakaf_project[j].nama;
        }
    }
    return textDisplay;
}
</script>

<style scoped>

</style>
